import axios from "./axiosinstance";

const RoleApi = {
  add: (payload) =>
    axios.post(
      "roles/add",
      payload
    ),

  list: () =>
    axios.get(
      "roles/list"
    ),

  update: (payload) =>
    axios.post(
      "roles/update",
      payload
    ),

  updateStatus: (payload) =>
    axios.post(
      "roles/update-status",
      payload
    ),

  delete: (payload) =>
    axios.post(
      "roles/delete",
      payload
    ),
};

export default RoleApi;